export const BUS_EVENT_TASK_VIEW_OPEN = 'task-view-open'